export default {"src":"/_next/static/media/icShare.26834d79.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};